import React, { useEffect, useContext } from 'react';
import { Highlight, useHits, useInstantSearch } from 'react-instantsearch';
import ContentLoader from 'react-content-loader';
import GtmContext from '../../contexts/GtmContext';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';
import { useFeatureFlag } from '../../hooks/useFeatureFlag/useFeatureFlag';

const Categories = () => {
  const { results: searchResults } = useHits();
  const { status } = useInstantSearch();
  const isSearchStalled = status === 'stalled';
  const searching = status === 'loading';
  const { gtm, setGtm } = useContext(GtmContext);
  const hits = searchResults && searchResults.hits;
  const isLoading = !searchResults || searching || isSearchStalled;
  const hasResults = searchResults && searchResults.nbHits !== 0;
  const isNewSearch = useFeatureFlag('isSearchOverlayNewDesign');
  const categoriesLimit = isNewSearch ? 4 : 3;

  const { query } = searchResults;

  useEffect(() => {
    if (hasResults) {
      setGtm({
        ...gtm,
        suggestions: {
          ...gtm.suggestions,
          category: hits.slice(0, categoriesLimit).map((c, i) => ({
            label: c.title,
            position: i + 1,
          })),
        },
      });
    } else {
      setGtm({
        ...gtm,
        suggestions: {
          ...gtm.suggestions,
          category: undefined,
        },
      });
    }
  }, [hasResults]);

  const clickGtmHandler = (e, hit, i) => {
    window.dataLayer.push({
      ...gtm,
      event: 'custom.search.suggested.click',
      label: hit.title,
      suggestions: {},
      suggestion: {
        type: 'category',
        label: hit.title,
        position: i + 1,
      },
      products: [],
    });

    pushToDataLayer({
      event: 'click_category',
      search_term: query,
      search_type: 'suggested search',
      label: hit?.title,
      info: {
        url: e?.currentTarget?.href,
      },
      method: 'undefined',
      filters: {},
    });
  };

  if (isLoading) {
    return [...Array(categoriesLimit)].map((e, i) => (
      <ContentLoader
        key={i}
        speed={1}
        width={250}
        height={9}
        viewBox="0 0 250 9"
        backgroundColor="#ececec"
        foregroundColor="#cccccc"
      >
        <rect x="0" y="2" rx="3" ry="3" width="250" height="5" />
      </ContentLoader>
    ));
  }

  if (hasResults) {
    return (
      <>
        {hits.slice(0, categoriesLimit).map((hit, i) => {
          return (
            <li key={hit.objectID}>
              <a href={'/collections/' + hit.url} onClick={e => clickGtmHandler(e, hit, i)}>
                <Highlight hit={hit} attribute="title" highlightedTagName="em" />
              </a>
            </li>
          );
        })}
      </>
    );
  } else {
    return <div>No results</div>;
  }
};

export default Categories;
